export default {

  // FrontPage.vue
  frontPageRequirementTitle: '我的',
  frontPageProvideTitle: '供应',
  frontPagePersonalCenterTitle: '我的',
  login: '登录',
  home_chatWithOctopie: '正在理解你的想法',
  home_chatNeedUnderstood: '已理解你的想法',
  home_draftBannerTitle: '继续完善你的消息',
  home_draftBannerSubtitle: 'AI 已帮你整理好，点这里继续',
  home_tabHome: '首页',
  // App.vue
  appRequirementTitle: '您的每一条需求/吐槽我们都将认真倾听',
  appRequirementBtn: '提交',
  appSubmitSuccess: '提交成功，感谢您的反馈',
  appFeedbackLink: '提需求/吐槽',
  mobile_banner_text: '为了获得最佳体验，请使用 App',
  mobile_banner_btn: '下载 App',

  // 通用
  loading: '加载中...',
  confirm: '确认',
  cancel: '取消',
  save: '保存',
  delete: '删除',
  edit: '编辑',
  add: '添加',
  search: '搜索',
  refresh: '刷新',
  change_batch: '换一换',
  back: '返回',
  submit: '提交',
  close: '关闭',
  ok: '确定',
  yes: '是',
  no: '否',
  send: '发送',
  block: '屏蔽',
  more: '更多',
  logout: '退出登录',
  settings: '设置',
  view_guide: '查看引导',
  feedback: '意见反馈',
  feedback_title: '意见反馈',
  feedback_new: '新增反馈',
  feedback_empty: '暂无反馈',
  feedback_hint: '说说你的想法...',
  feedback_submit: '提交',
  feedback_submit_success: '反馈提交成功',
  feedback_submit_failed: '反馈提交失败',
  feedback_reply_label: '平台回复',
  register: '注册',
  name: '昵称',
  email: '邮箱',
  mobile: '手机号',
  password: '密码',
  verification_code: '验证码',
  company_name: '北京两少科技有限公司',
  all_rights_reserved: '版权所有',
  footerVersion: '版本 {version}',
  copy: '复制',
  regenerate: '重新生成',
  generate: '生成',
  contact_now: '立即联系',
  yours: '你的',
  xiaoyao_analysis: 'AI 分析',
  brand_name: '章摇摇',
  anonymous: '匿名',
  no_summary: '暂无摘要',
  file: '文件',
  discover: '发现',
  discover_title: '发现',
  discover_hotChannels: '热门频道',
  discover_allChannels: '全部',
  discover_searchChannel: '搜索频道',
  discover_noChannels: '暂无频道',

  // 提示信息
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  networkError: '网络错误，请稍后重试',
  dataLoadingFailed: '数据加载失败',
  noData: '暂无数据',
  deleteConfirm: '确定要删除吗？',
  saveConfirm: '确定要保存吗？',

  // 表单验证
  required: '此项为必填项',
  emailInvalid: '请输入有效的邮箱地址',
  phoneInvalid: '请输入有效的手机号码',
  passwordTooShort: '密码长度不能少于{min}位',
  passwordMismatch: '两次输入的密码不一致',

  // 时间
  today: '今天',
  yesterday: '昨天',
  justNow: '刚刚',
  minutesAgo: '{min}分钟前',
  hoursAgo: '{hour}小时前',
  daysAgo: '{day}天前',

  // Footer
  about: '关于',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  footerSupport: '帮助与支持',

  // Register
  registerAgeConfirm: '我已年满13周岁',
  registerAgeConfirm18: '我已年满18周岁',
  registerTermsPrefix: '我已阅读并同意',
  registerTermsAnd: '和',
  registerAgeError: '请确认你的年龄',
  registerTermsError: '请同意条款和隐私政策',

  // Chat
  chatPrivacyTip: '在群里输入你想说的话，小摇会先和你聊天澄清细节。你确认后，你的消息和匹配摘要会一起发出去，小摇再持续帮你匹配。',
  aiChat_quickSuggestions: '试试说',
  aiChat_welcome: "嗨，说说你想找什么吧～",

  // Chat - 小摇 Progress Steps (new)
  aiChat_readyToPost: '细节已理解，发布后小摇帮你摇到对的人',
  aiChat_readyToPostHint: '发布后想补充细节，随时继续和小摇聊',
  aiChat_progressStep1: '理解细节',
  aiChat_progressStep1Done: '细节已理解',
  aiChat_progressStep2: 'AI 总结',
  aiChat_progressStep2Desc: 'AI 帮你提炼，方便群友匹配',
  aiChat_progressStep3: '发布到群',
  aiChat_progressStep3Desc: '发布后小摇帮你摇到对的人',
  aiChat_publishExtraHint: '请输入你想对群友说的话',
  aiChat_publishMsgRequired: '必填',
  aiChat_publishMsgLabel: '你要对群友说的话',
  aiChat_matchSummaryLabel: 'AI 总结',

  ai_generated_label: 'AI 生成',

  ai_content_disclaimer: '本对话中 AI 生成的内容仅供参考，请注意甄别',
  aiChat_publishSuggestionHint: '点击替换',
  aiChat_allowDirectContact: '允许直接联系',
  aiChat_allowDirectContactDesc: '其他人无需匹配即可直接联系你',
  channel_chat_session_publishToChannel: '发布到章鱼群',
  aiChat_newChat: '重置',

  // 群 / 频道
  home_tabChannels: '章鱼群',
  channels_title: '章鱼群',
  channels_myChannels: '加入的群',
  channels_discover: '发现',
  channels_noChannels: '暂无群',
  channels_noMyGroupsTitle: '你还没有加入任何群',
  channels_noMyGroupsSubtitle: '去搜索一个群加入，开始认识新朋友吧',
  channels_searchGroupsBtn: '搜索群',
  channels_loginPrompt: '请登录后查看群',
  channels_create: '建章鱼群',
  channels_search: '搜索章鱼群',
  channels_searchMyGroups: '搜索我的章鱼群',
  channels_searchHint: '搜索',
  channels_searchHintChats: '搜索聊天...',
  channels_searchHintGroups: '搜索群...',
  channels_searchHintMy: '搜索加入的群...',
  channels_joinByCode: '群码加入',
  channels_joinByCodeTitle: '通过章鱼群码加入',
  channels_joinByCodeHint: '输入章鱼群码',
  channels_joinByCodeConfirm: '加入',
  channels_joinByCodeNotFound: '未找到该群',
  channels_createNewGroup: '创建新章鱼群',
  channels_noResults: '未找到相关群',
  channel_detail_join: '进章鱼群',
  channel_detail_leave: '退出',
  channel_detail_members: '成员',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} 加入了群',
  channelJoinMsg_twoJoined: '{name1}、{name2} 加入了群',
  channelJoinMsg_multiJoined: '{name1}、{name2} 和另外 {n} 人加入了群',
  channelJoinMsg_oneAndMoreJoined: '{name} 和另外 {n} 人加入了群',
  channelJoinMsg_membersJoined: '{n} 人加入了群',

  // Feed
  channels_feed: '聊天',
  channels_groups: '群',
  feed_related: '相关',
  feed_recommend: '推荐',
  feed_empty: '还没有动态，先去热门群逛逛吧',
  feed_goToGroup: '进群看看',
  feed_joinGroupAndSendMsg: '加入群聊，发条消息',
  channel_detail_channelCode: '章鱼群码',
  channel_detail_invitePhrase: '邀你加入「{name}」\n群口令 {code}，打开App自动进群 · AI先帮你澄清，再摇到对的人',
  channel_detail_post: '发到群里',
  channel_detail_aiHint: "在群里写消息，小摇会先澄清细节",
  channel_input_hint: '说点什么…',
  channel_leave_confirm_message: '确定要退出该群吗？退出后将不再收到群消息。',
  channel_invite_notFound: '群不存在或链接已失效',
  channel_invite_joinBtn: '下载章摇摇App',
  channel_invite_hint: '下载 App 后，扫描此二维码或搜索群名即可加入',
  channel_invite_globalHintTitle: '您当前要下载的是国际版App',
  channel_invite_globalHintIOS: '国内App Store无法直接下载，建议切换至非中国区Apple Store搜索 OctoSay，或点击下方直接下载',
  channel_invite_globalHintAndroid: '国内无法直接访问Google Play，建议点击下方直接下载APK安装包，或尝试前往Google Play',
  channel_invite_globalHintDefault: '国内应用商店可能无法直接下载，建议点击下方直接下载APK安装包，或尝试前往App Store',
  channel_invite_globalBtnAppStore: '前往App Store',
  channel_invite_globalBtnGooglePlay: '前往Google Play',
  channel_invite_globalBtnAPK: '直接下载APK',
  channel_invite_defaultDesc: '加入 {name} - 章摇摇',
  share: '分享',
  share_channel: '分享群',
  share_channel_link: '分享链接',
  channel_detail_inviteCode: '群口令',
  channel_detail_copyLink: '复制链接',
  share_session_title: '章摇摇上的一个帖子',
  share_match_title: '章摇摇上的一个匹配',
  share_session_text: '{userName}：{summary}',
  share_session_text_no_summary: '看看 {userName} 在章摇摇上发了什么',
  session_share_notFound: '帖子不存在或链接已失效',
  session_share_fromChannel: '来自章鱼群',
  session_share_downloadBtn: '下载章摇摇App',
  session_share_hint: '下载 App 后即可查看完整帖子并加入群聊',
  session_share_openInApp: '在 App 中打开',
  toast_link_copied: '链接已复制',
  toast_no_share_data: '没有可分享的内容',
  channels_joinByQR: '二维码',
  channels_joinByQRWebHint: '网页端暂不支持扫码，请输入章鱼群码加入',
  channels_joinByQRTitle: '扫码加群',
  channel_detail_qrCode: '二维码',
  channel_detail_qrCodeSave: '保存图片',
  channel_detail_qrCodeSaveHint: '右键点击图片保存',
  channel_detail_qrCodeSaved: '已保存到相册',
  channel_detail_qrCodeSaveFailed: '保存失败，请重试',
  channel_detail_locateFailed: '定位消息失败',
  channel_detail_locateError: '定位消息出错',
  channel_detail_myMessages: '我的消息',
  channel_detail_searchMessages: '搜索消息',
  channel_detail_aiChat: '小摇对话',
  channel_detail_matchHistory: '匹配历史',
  channel_create_title: '建章鱼群',
  channel_create_name: '章鱼群名称',
  channel_create_description: '章鱼群简介',
  channel_create_submit: '创建',
  channelCreate_aiAssist: '小摇将帮你创建一个合适的群',
  channelCreate_nameHint: '输入群名称',
  channelCreate_descHint: '描述你的群是做什么的',
  channelCreate_creating: '创建中...',
  channelCreate_created: '群创建成功！',
  channelCreate_failed: '创建群失败',
  channelCreate_welcomeMsg: "你好！我是小摇，我来帮你创建群。告诉我你想建什么样的群——比如主题或用途，我会帮你整理成群名称和群介绍，还会自动生成群头像。",
  channelCreate_aiHint: '写下你的群主题...',
  channelCreate_clarifyingProgress: '正在整理你的群主题...',
  channelCreate_readyToCreate: '可以创建章鱼群了',
  channelCreate_step1: '说明主题',
  channelCreate_step1Done: '想法已明确',
  channelCreate_step2: '创建章鱼群',
  channelCreate_confirmBtn: '确认创建',
  channelCreate_publicNotice: '群是公共交流空间，供有共同兴趣的人在此聚集。群不属于创建者个人所有。平台有权对群进行管理、调整或合并。欢迎将群分享给可能感兴趣的其他人。',
  channelCreate_similarGroupsTitle: '发现相似章鱼群',
  channelCreate_similarGroupsDesc: '这些群可能适合你',
  channelCreate_exactMatchHint: '已存在同名群！',
  channelCreate_joinHint: '这些已有群可能适合你',
  channelCreate_joinExisting: '加入已有章鱼群',
  channelCreate_stillCreate: '仍要创建新章鱼群',
  channel_chat_session_comments: '评论',
  channel_chat_session_commentHint: '写一条评论...',
  channel_chat_session_sendComment: '回复',
  channel_chat_session_loadMore: '加载更多',
  channel_chat_session_noComments: '暂无评论',
  channel_chat_session_deleteComment: '删除',
  channelSearch_title: '群内搜索',
  channelSearch_placeholder: '搜索消息...',
  channelSearch_onlyMine: '仅我的发布',
  channelSearch_tabAllMessages: '群消息',
  channelSearch_tabMyMessages: '我的消息',
  chatMsgSearch_placeholder: '搜索消息',
  chatMsgSearch_tabMsgs: '消息',
  chatMsgSearch_tabContacts: '联系人',
  chatMsgSearch_emptyPrompt: '输入关键词搜索消息',
  chatMsgSearch_tooShort: '至少输入 2 个字再搜索',
  chatMsgSearch_contactEmptyPrompt: '输入用户名或邮箱搜索联系人',
  chatMsgSearch_noContacts: '未找到相关联系人',
  chatMsgSearch_inChatPlaceholder: '在当前聊天中搜索',
  channelHistory_title: '历史消息',
  channelHistory_myMessages: '我发的消息',
  channelHistory_loadMore: '加载更多',
  channel_settings_push: '章鱼群消息通知',
  channel_settings_commentPush: '评论通知',
  channel_settings_likePush: '点赞通知',
  channel_settings_receiveNotifications: '接收通知',
  channel_settings_directContact: '允许直接联系',
  session_published: '已发布',
  session_publishFailed: '发布失败',
  session_setDirectContactSuccess: '设置已保存',
  session_setDirectContactFailed: '保存设置失败',
  session_setPrivate: '设为私密',
  session_setPublic: '设为公开',
  session_pauseMatching: '暂停匹配',
  session_resumeMatching: '恢复匹配',
  session_matchPausedToast: '已暂停匹配',
  session_matchResumedToast: '已恢复匹配',
  match_matchingPausedTitle: '匹配已暂停',
  match_reasonTag: '匹配理由',
  match_matchingPausedHint: '随时可恢复匹配',
  session_confirmSetPrivate: '确定将此内容设为私密？其他用户将无法查看。',
  session_messageIsPrivate: '该消息为私密消息',
  chatSessionComment_replyHint: '写一条评论...',
  chatSessionComment_reply: '评论',
  chatSessionComment_count: '条评论',
  chatSessionMatch_count: '{n}个匹配',
  chatSessionComment_replyTo: '回复',
  chatSessionComment_inputHint: '写评论...',
  chatSessionComment_send: '发送',
  chatSessionComment_delete: '删除',
  chatSessionComment_deleteConfirm: '确定要删除这条评论吗？',
  chatSessionComment_loadMore: '加载更多',
  chatSessionComment_noMore: '没有更多评论了',
  chatSessionComment_loginToComment: '请登录后评论',
  chatSessionComment_viewEarlier: '查看更早{n}条回复',
  chatSessionLike_like: '点赞',
  chatSessionLike_liked: '已点赞',
  chatSessionLike_count: '个赞',
  chatSessionBookmark_bookmark: '收藏',
  chatSessionBookmark_bookmarked: '已收藏',
  chatSessionMatch_viewMatches: '查看匹配',
  chatSessionMatch_matchHistory: '匹配历史',
  chatSessionMatch_noMatches: '暂无匹配',
  channel_match_achievement: '已有 {count} 个内容成功匹配',
  channel_match_achievement_view: '查看 →',
  channel_matchHistory_title: '频道匹配历史',
  chatSessionMatch_matchedAt: '匹配于 {time}',
  discover_userMsgLabel: 'TA说',
  common_loading: '加载中...',
  common_sending: '发送中...',
  common_error: '错误',
  common_success: '成功',
  common_me: '我',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "小摇在澄清你的想法，确保发出去的每条消息都有效；发布后会持续为你摇对的TA",
  aiChat_clarifyingAlmostDone: '即将完成，请确认一下',
  aiChat_clarifyingOneMore: '预计再回答 1 个问题即可，马上就能发布',
  aiChat_clarifyingRemaining: '预计还需 {count} 轮对话，很快就好',
  aiChat_clarifyingEvaluating: '正在评估进度...',
  aiChat_setPublicMatch: '设为公开并匹配',
  aiChat_needsClarifiedPublic: "我已经懂你了。你确认发布后，小摇会持续为你摇合适的人，有新结果会第一时间告诉你。\n也可以随时告诉我更多细节。",
  aiChat_needsClarifiedPrivate: '已大概知晓你的想法！设为公开让小摇持续为你摇合适的人！',
  aiChat_setPublicTitle: '设为公开',
  aiChat_setPublicMessage: '你的内容将对其他人可见，以便章摇摇持续为你摇到合适的TA。\n\n将分享的信息：\n• 你的用户名和头像\n• 你的内容摘要\n• 对话内容\n\n你可以随时将其设回私密。',
  aiChat_findMatches: '查看匹配结果',
  aiChat_publishing: '发布中...',
  aiChat_matchSectionTitle: '你的消息最适合发布到这些群，点群名直接发布',
  aiChat_joinedBadge: '已加入',
  aiChat_matchSectionEmpty: '暂时没有匹配度高的群，可以直接创建一个新群发布',
  aiChat_suggestPublishCreateNew: '创建新群',
  aiChat_repickChannel: '重新选群',
  aiChat_creatingChannelTitle: '没找到合适的群，正在为你创建',
  aiChat_creatingChannelHint: '小摇正在按你的需求起名建群，完成后直接进入发布，通常需要 10~30 秒',
  aiChat_publishToChannelHint: '将发布到「{name}」',
  aiChat_pickChannelTitle: '选择发布的群',
  aiChat_matchingChannelTitle: '正在为你匹配合适的群',
  aiChat_matchingChannelHint: '小摇正在根据你的需求搜索，通常需要几秒到半分钟，请稍候',
  aiChat_matchUnavailableTitle: '推荐暂时不可用',
  aiChat_matchUnavailableHint: '可以直接搜索下面的群，或关闭后重新打开发布再试',
  aiChat_waitSlowHint: '匹配还在进行中，请再稍等片刻；也可以先在下方搜索群',
  aiChat_creatingSlowHint: '建群还在进行中，请再稍等片刻；建好后会直接带你进入发布',
  aiChat_pickChannelEmptyHint: '没找到相关的群，创建一个新群发布吧',
  aiChat_loadMore: '加载更多',
  sidebar_publish: '发布消息',
  chat_selectLocationOnMap: '选择位置',

  // App.vue 新增
  placeholder_email: '请输入邮箱',
  placeholder_mobile: '请输入手机号',
  placeholder_password: '请输入密码',
  placeholder_name: '请输入你的昵称',
  random_nickname: '随机',
  placeholder_verification_code: '请输入验证码',
  sending: '发送中...',
  registering: '注册中...',
  send_code: '发送验证码',
  retry_in_seconds: '{countdown}秒后重试',
  toast_enter_email: '请输入邮箱',
  toast_enter_mobile: '请输入手机号',
  toast_invalid_email: '请输入有效的邮箱格式',
  toast_invalid_mobile: '请输入有效的手机号码',
  toast_send_code_failed: '验证码发送失败',
  toast_code_sent: '验证码已发送至邮箱',
  toast_code_sent_sms: '验证码已发送至手机',
  toast_send_code_error: '验证码发送失败，请稍后重试',
  toast_fill_all_fields: '请填写所有字段',
  toast_login_failed: '登录失败',
  toast_login_success: '登录成功',
  oauthOr: '或',
  toast_oauth_login_failed: 'Google 登录失败',
  toast_oauth_login_error: 'Google 登录出错，请重试',
  toast_login_error: '登录失败，请稍后重试',
  toast_register_failed: '注册失败',
  toast_register_success: '注册成功',
  toast_register_error: '注册失败，请稍后重试',

  // AdBanner.vue
  ad: '广告',

  // ContactAdGate.vue
  contactAd_gateTitle: '联系前的短暂等待',
  contactAd_gateSubtitle: '这几秒广告让小摇能持续免费运营，谢谢支持！',
  contactAd_waitBtn: '{sec} 秒后可继续',
  contactAd_continueBtn: '继续联系',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: '私聊',

  // AiMatch.vue
  ai_welcome_msg: '我是小摇，告诉我你想说什么——找搭子、找伙伴、技能交换、或任何事。',
  default_username: '用户',

  // AvatarCropDialog.vue
  crop_hint: '捏合缩放，拖动调整',
  toast_crop_failed: '裁剪图片失败',

  // ChatBox.vue
  loading_match_info: '正在加载匹配信息...',
  view_match_details: '查看匹配详情',
  step_clarify_needs: '简单聊聊',
  step_ai_matching: '发布到群',
  step_connect: 'AI持续匹配',
  make_private: '设为私密',
  setting: '设置中...',
  action_photo: '照片',
  channel_image_limit: '仅支持1张',
  action_file: '文件',
  action_video: '视频',
  action_location: '位置',
  hint_get_app: '下载APP保持联系',
  match_finding_title: '匹配结果',
  match_finding_subtitle: '小摇正在持续为你摇合适的人',
  match_time_hint: '此过程通常需要1-2分钟',
  match_result_stats: '找到了 {matched} 个匹配{interested}',
  match_tap_to_connect: '点击开始私聊',
  match_channel_hint: '正在群 #{channel} 中匹配。优先同群匹配，但必要时也可能包含其他群。',
  label_perfect_match: '最佳匹配',
  label_worth_a_look: '值得一看',
  match_no_result_title: '正在为你寻找合适的TA',
  match_no_result_desc: '分享更多细节，帮助章摇摇摇到合适的TA。',
  go_back: '返回',
  no_public_requirements: '暂无公开内容',
  channelEmpty_title: '群内静悄悄',
  channelEmpty_subtitle: '成为第一个分享想法的人吧',
  channelEmpty_hint: "写下你的想法，小摇会帮你澄清并持续匹配，让消息不沉底",
  channelEmpty_action: '说说你的想法',
  stay_connected: '保持联系',
  download_app_desc: '下载APP即可聊天，并在有人联系你时立即收到通知！',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: '直接下载APK',
  match_history: '匹配历史',
  no_match_history: '暂无匹配历史',
  finding_matches: '小摇正在持续为你摇人 - 发布消息到群后即可',
  discover_connect_hint: '匹配成功即可开始聊天',
  match_initializing: '正在初始化...',
  placeholder_login_to_chat: '请登录后告诉我你想说什么',
  toast_need_clear: '你的想法已明确！',
  toast_ai_responding: '小摇正在回复，请稍候...',
  toast_uploading_image: '正在上传图片，请稍候...',
  toast_uploading_file: '正在上传文件，请稍候...',
  toast_max_photos: '最多允许 {max} 张照片',
  toast_uploading: '正在上传，请稍候...',
  toast_file_too_large: '{name} 超过5MB限制',
  toast_video_too_large: '{name} 超过20MB限制',
  toast_video_processing: '视频处理中，请稍候…',
  toast_upload_failed: '上传失败，请重试',
  toast_upload_link_failed: '获取上传链接失败',
  analyzing_image: '正在分析图片...',
  toast_location_confirmed: '位置已确认',
  toast_location_selected: '位置已选择',
  toast_enter_search: '请输入搜索内容',
  toast_search_failed: '搜索失败',
  toast_no_locations: '未找到位置',
  toast_search_error: '搜索失败，请重试',
  toast_located_at: '定位到：{address}',
  toast_shared_finding: '已分享！正在寻找匹配...',
  toast_update_failed: '更新失败',
  toast_set_private: '已设为私密',
  toast_no_matches: '未找到匹配',
  toast_matches_found: '找到了 {count} 个匹配',
  toast_start_conversation_first: '请先开始对话',
  toast_load_history_failed: '加载匹配历史失败',
  toast_ai_timeout: '小摇响应超时，请重试',
  toast_message_blocked: '消息被屏蔽',
  network_disconnected: '网络已断开',
  toast_publish_success: '已发布到群！',
  toast_publish_failed: '发布到群失败',

  // ChatMsgList.vue
  collapse_thinking: '收起思考过程',
  expand_thinking: '展开思考过程',
  thinking: '思考中',
  select_date: '选择日期',
  selected_location: '已选位置',
  msg_blocked: '被屏蔽',
  retry: '重试',
  msg_read: '已读',
  msg_sent: '已送达',
  msg_unread: '未读',
  label_start_datetime: '开始日期和时间：',
  label_end_datetime: '结束日期和时间：',
  toast_select_start_datetime: '请选择开始日期和时间',
  toast_end_before_start: '结束时间不能早于开始时间',
  report_message: '举报消息',
  block_user: '屏蔽用户',
  msg_revoke: '撤回',
  msg_quote: '引用',
  msg_revoked_self: '你撤回了一条消息',
  msg_revoked_other: '对方撤回了一条消息',
  // 引用块内使用中性文案：撤回者是被引用消息的发送者，与当前消息方向无关
  msg_revoked_generic: '消息已撤回',
  // 平台处置（内容安全人工复核拦截），区别于本人撤回
  msg_revoked_platform: '该消息因违规已被平台撤回',
  msg_blocked_label: '该消息已被平台屏蔽',
  toast_revoke_success: '已撤回',
  toast_revoke_failed: '撤回失败',
  toast_load_data_failed: '加载数据失败，请刷新重试',
  toast_file_url_missing: '文件链接不存在',
  toast_block_success: '用户屏蔽成功',
  toast_block_failed: '屏蔽用户失败',

  // ChatSession.vue
  no_more_records: '没有更多了',
  title_needs_clarified: '想法已明确',
  title_clarifying: '正在帮你理清想法',
  title_public: '公开',
  title_private: '私密',
  badge_clarified: '已明确',
  badge_clarifying: '明确中',
  badge_only_me: '仅自己',
  badge_expired: '已过期',
  title_expired: '已过期',
  no_chat_history: '暂无聊天记录',
  toast_load_sessions_failed: '加载聊天会话失败：{msg}',
  toast_load_sessions_error: '加载聊天会话失败，请刷新重试',

  // ContactMethods.vue
  block_status_banner: '你已屏蔽此用户',
  unblock_user: '取消屏蔽',
  toast_block_missing_id: '无法屏蔽：缺少用户ID',
  dialog_block_confirm: '你确定要屏蔽 {name} 吗？你将不再收到对方的消息。',
  toast_user_blocked: '已屏蔽 {name}',
  toast_unblock_missing_id: '无法解除屏蔽：缺少用户ID',
  toast_user_unblocked: '{name} 已取消屏蔽',

  // BlockedUsers.vue
  blocked_users: '屏蔽的用户',
  blocked_users_empty: '还没有屏蔽的用户',
  blocked_users_empty_hint: '被你屏蔽的用户将无法再给你发送消息',
  blocked_users_unblock: '取消屏蔽',
  dialog_unblock_confirm: '解除后，对方将可以重新给你发送消息。',
  toast_unblock_success: '已解除屏蔽',
  toast_unblock_failed: '解除屏蔽失败，请重试',
  blocked_users_load_failed: '加载失败，点击重试',
  blocked_users_blocked_at: '屏蔽于 {date}',
  blocked_users_unknown_user: '未知用户',

  // Contacts.vue
  no_connections: '暂无私聊',
  chat_with: '与 {name} 聊天',
  toast_load_contacts_failed: '加载联系人失败：{msg}',
  toast_load_contacts_error: '加载联系人失败，请刷新重试',
  time_just_now: '刚刚',
  time_minutes_ago: '{min}分钟前',
  time_hours_ago: '{hour}小时前',
  time_days_ago: '{day}天前',

  // InteractionNotification.vue
  interaction_notification_title: '互动通知',
  interaction_notification_subtitle: '查看评论和点赞',
  interaction_notification_empty: '暂无互动通知',
  interaction_notification_comment: '评论了你：{content}',
  interaction_notification_like: '赞了你的帖子',
  interaction_notification_reply: '回复了你：{content}',
  interaction_notification_bookmark: '收藏了你的帖子',
  toast_load_notifications_failed: '加载通知失败：{msg}',
  toast_load_notifications_error: '加载通知失败，请刷新重试',
  mark_all_read: '全部已读',
  toast_mark_all_read_failed: '操作失败，请重试',
  contacts_dnd: '消息免打扰',
  dnd_enabled: '已开启免打扰',
  dnd_disabled: '已关闭免打扰',
  dnd_action_enable: '开启免打扰',
  dnd_action_disable: '关闭免打扰',

  // Discover.vue
  toast_load_sessions_failed: '加载会话失败：{msg}',
  toast_load_sessions_error: '加载会话失败',
  discover_noMessages: '暂无消息',

  // EmojiInputArea.vue
  placeholder_default: '和小摇补充更多细节',
  userChat_typeMessage: '输入消息...',
  select_emoji: '选择表情',
  badge_new: '新',
  channel_search_placeholder: '请输入频道',
  channel_picker_empty: '请输入频道',

  // FrontPage.vue
  tab_chat_with_ai: '让章摇摇懂你',
  history_chats: '历史',
  tab_connections: '摇到的TA',
  tab_conversations: '消息',
  tab_profile: '我的',
  new_session: '新建',
  history_tab_chats: '我的',
  history_tab_matches: '摇到的TA',
  channels_octosay: '章鱼群',
  tab_matches: '摇到的TA',
  tab_messages: '消息',

  // Header.vue
  slogan: '章摇摇 - 小摇理解你，摇到对的TA',
  app_name: '章摇摇',
  slogan_short: '小摇理解你，摇到对的TA',
  slogan_ai: 'AI 帮你摇到对的人',
  get_the_app: '下载APP',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: '或在应用商店搜索 章摇摇',

  // MapLocationPicker.vue
  placeholder_search_location: '搜索位置...',
  coords_display: '位置：{lng},{lat}',
  toast_no_geolocation: '您的浏览器不支持地理定位',
  toast_location_permission_denied: '无法获取您的位置，请检查定位权限',
  loading_address: '正在解析地址...',

  // MatchedSession.vue
  created_at: '创建于：{time}',
  ai_match_analysis: 'AI 匹配分析',
  error_missing_session_params: '缺少必要的会话参数',
  match_private_hint: '该会话已设为私有，内容不可查看',

  // PersonalCenter.vue
  label_name: '昵称：',
  placeholder_enter_name: '输入你的昵称',
  label_bio: '简介：',
  placeholder_enter_bio: '写点什么介绍一下自己吧',
  placeholder_bio_empty: '写点儿什么介绍下自己吧',
  bio: '简介',
  delete_account: '注销账号',
  delete_warning: '此操作无法撤销。',
  delete_data_intro: '以下数据将被永久删除：',
  delete_item_profile: '你的个人资料信息',
  delete_item_chat: '聊天记录和会话',
  delete_item_contact: '联系人信息',
  delete_item_all: '所有关联数据',
  final_confirmation: '最终确认',
  delete_confirm_prompt: '请键入 "delete" 以确认：',
  placeholder_type_delete: '键入 delete',
  private_token: '私有令牌',
  token_desc: '生成用于API访问的令牌',
  toast_not_logged_in: '用户未登录',
  toast_name_required: '昵称不能为空',
  toast_save_success: '保存成功',
  toast_save_failed: '保存失败',
  toast_image_too_large: '图片超过5MB限制',
  toast_avatar_updated: '头像已更新',
  toast_avatar_failed: '头像更新失败',
  toast_upload_failed: '上传失败',
  toast_token_generated: '令牌已生成',
  toast_token_failed: '生成令牌失败',
  toast_copied: '已复制到剪贴板',
  toast_copy_failed: '复制失败',
  toast_account_deleted: '账号注销成功',
  toast_delete_account_failed: '注销账号失败',
  toast_logout_success: '退出登录成功',
  toast_logout_failed: '退出登录失败',
  profile_tab_messages: '消息',
  profile_tab_comments: '评论',
  profile_tab_likes: '点赞',
  profile_tab_bookmarks: '收藏',
  profile_empty_messages: '还没有发过消息',
  profile_empty_comments: '还没有评论',
  profile_empty_likes: '还没有点赞',
  profile_empty_bookmarks: '还没有收藏',
  profile_reply_to: '回复{name}',
  profile_stats_posts: '消息',
  profile_stats_comments: '评论',
  profile_stats_likes: '获赞',
  profile_joined: '{date} 加入',

  // ReportDialog.vue
  report_message_title: '举报消息',
  report_reason_prompt: '请选择举报原因：',
  report_spam: '垃圾信息',
  report_harassment: '骚扰或欺凌',
  report_inappropriate: '不当内容',
  report_other: '其他',
  placeholder_report_desc: '请描述问题（可选）',
  toast_select_reason: '请选择原因',
  toast_report_success: '举报提交成功。感谢你的反馈。',
  toast_report_failed: '举报提交失败',

  // common.js
  ellipsis: '..',

  // ChatBox.vue 消息摘要前缀
  summary_image: '[图片]',
  summary_images: '[图片x{count}]',
  summary_file: '[文件]',
  summary_files: '[文件x{count}]',
  summary_video: '[视频]',
  summary_videos: '[视频x{count}]',
  summary_location: '[位置]',
  summary_locations: '[位置x{count}]',
  summary_emoji: '[表情]',
  summary_emojis: '[表情x{count}]',
  summary_voice: '[语音]',
  summary_voices: '[语音x{count}]',
  summary_mixed: '[混合内容]',
  summary_other: '[其他]',

  // 语音消息
  voice: '语音',
  voice_recording: '录音中...',
  toast_voice_too_short: '录音时间太短',
  toast_voice_failed: '语音发送失败',
  toast_mic_permission_denied: '无法访问麦克风，请在浏览器设置中开启权限',
  toast_recording_not_supported: '当前浏览器不支持语音录制',
  voice_load_failed: '语音加载失败',

  // Expire At
  aiChat_expireLine: '有效期至 {date}，随时告知小摇更新',
  aiChat_expireExpired: '内容已过期，不再对外展示，随时告知小摇更新过期时间',

  // MatchedSession.vue
  detail: '详情',

  // Match notification hints
  match_new_result_hint: '后续可能会有新的match结果，请安装app通过app接受及时通知',

  // Match notification hints
  match_connection_notify_hint: '匹配已建立并通知！快去打个招呼吧~',
  match_continuousMatching: '小摇正在持续为你摇合适的人',
  match_continuousMatchingHint: '有新的结果我会第一时间通知你',
  match_continuousMatchingOthers: '小摇正在持续为TA摇合适的人',
  match_continuousMatchingOthersHint: '有新的结果会更新展示在这里',
  match_noResultsTitleOthers: '正在为TA寻找合适的人',
  match_noResultsHintOthers: '小摇正在持续为TA摇合适的人，一旦找到会展示在这里',
  match_newMatchFound: '发现 {n} 个新匹配！',
  match_worth_exploring_hint: '由你决定是否主动联系。',

  // Matches filter tags
  filter_all: '全部',
  filter_best_connection: '最佳匹配',
  filter_worth_a_look: '值得一看',

  // LandingPage.vue (CN 门户)
  landing_brand_slogan: '章摇摇 - 小摇理解你，摇到对的TA',
  landing_hero_title: '写下想说的话，小摇澄清后一并发出去',
  landing_hero_subtitle: '小摇先帮你澄清细节，持续为你摇到合适的人',
  landing_download_on: '下载',
  landing_get_it_on: '获取',
  landing_direct_download: '直接下载',
  landing_how_title: '使用三步',
  landing_step1_title: '在群里写下消息',
  landing_step1_desc: '在章鱼群里输入你想表达的内容。消息不会直接发出去，小摇会先和你聊天澄清细节，让每条消息都清晰有用、值得匹配，而不是淹没在杂乱聊天里。',
  landing_step2_title: '确认后发布并匹配',
  landing_step2_desc: '你确认发布后，你的原消息和小摇提炼的匹配摘要会一起发到群里。小摇随后持续为你摇出最合适的TA，防止消息发完就沉底没人看到。',
  landing_step3_title: '匹配后自然聊',
  landing_step3_desc: '匹配成功后，双方都能看到彼此和小摇的聊天记录以及匹配摘要。有共同语境，破冰自然不尴尬，聊起来更轻松。',
  // Comparison Section
  landing_comparison_title: '为什么选择章摇摇？',
  landing_comparison_subtitle: '小摇帮你澄清细节、主动匹配。',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: '章摇摇',
  landing_cmp1_label: '内容质量',
  landing_cmp1_other: '广告、灌水、离题消息刷屏',
  landing_cmp1_octo: '仅展示AI澄清好的需求卡片',
  landing_cmp2_label: '找人',
  landing_cmp2_other: '发了消息然后祈祷有人看到',
  landing_cmp2_octo: '小摇主动为你匹配合适的人',
  landing_cmp3_label: '噪音程度',
  landing_cmp3_other: '需要翻阅上百条消息',
  landing_cmp3_octo: '零噪音，每条消息都有意义',
  landing_cmp4_label: '上手难度',
  landing_cmp4_other: '找服务器、翻频道、自己摸索',
  landing_cmp4_octo: '在群里写消息，小摇来澄清匹配',
  landing_cmp_other_wechat: '微信',
  landing_cmp_other_xhs: '小红书',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: '群消息刷屏、广告灌水',
  landing_cmp1_xhs: '营销笔记多、真假难辨',
  landing_cmp1_facebook: '广告和标题党刷屏',
  landing_cmp1_reddit: '灌水、离题帖到处都是',
  landing_cmp2_wechat: '只能靠通讯录和拉群',
  landing_cmp2_xhs: '得自己搜索、慢慢翻找',
  landing_cmp2_facebook: '局限在已有好友和小组里',
  landing_cmp2_reddit: '自己翻版块、发帖等回复',
  landing_cmp3_wechat: '群聊几百条消息爬楼',
  landing_cmp3_xhs: '信息流全是推荐和广告',
  landing_cmp3_facebook: '推荐帖和广告刷不完',
  landing_cmp3_reddit: '评论区要翻上百条',
  landing_cmp5_label: '找人方式',
  landing_cmp5_wechat: '自己一个个问、碰运气',
  landing_cmp5_xhs: '发笔记等评论、还得自己筛',
  landing_cmp5_facebook: '得自己在群里到处问',
  landing_cmp5_reddit: '自己发帖、等回复、再筛选',
  landing_cmp5_octo: 'AI帮你持续自动找人',
  landing_features_title: '核心特性',
  landing_feature1_title: '发布前先澄清',
  landing_feature1_desc: '不需要填表。在群里写下你想说的话，小摇会在发布前先和你聊天、追问细节，真正理解你的需求',
  landing_feature2_title: '章鱼群匹配',
  landing_feature2_desc: '你的消息和匹配摘要一起发到章鱼群，章摇摇持续从群友中为你摇到答案或共鸣，告诉你为什么适合你',
  landing_feature3_title: '主动匹配',
  landing_feature3_desc: '你确认发布后，小摇会持续在群里为你寻找契合的人，不用你搜索或翻找',
  landing_feature4_title: '章鱼群社区',
  landing_feature4_desc: '加入感兴趣的章鱼群，获取答案、找到搭子，让连接更自然更有温度',
  landing_feature5_title: '隐私保护',
  landing_feature5_desc: '发送后可选择设为私有，仅自己可见，完全掌控你的信息',
  landing_feature6_title: '有效沟通',
  landing_feature6_desc: '没有噪音，没有杂乱的干扰消息，每条消息都有意义',
  landing_usecases_title: '适用于众多场景',
  landing_usecases_subtitle: '无论你想做什么、需要什么，小摇都能理解并帮你搞定',
  landing_usecase_game: '游戏搭子',
  landing_usecase_language: '语言交换',
  landing_usecase_skill: '技能交换',
  landing_usecase_roommate: '找室友',
  landing_usecase_travel: '旅行搭子',
  landing_usecase_sports: '运动伙伴',
  landing_usecase_study: '学习搭档',
  landing_usecase_anything: '...或分享任何事',
  landing_cta_title: '准备好了吗？',
  landing_cta_desc: '加入章鱼群，写下你想说的话，让小摇先澄清、你确认后再发布，并持续帮你摇到对的人。现在就开始。',
  landing_use_now: '立即使用',
  landing_groups: '章鱼群',

  // OnboardingPage.vue
  onboarding_skip: '跳过',
  onboarding_next: '下一步',
  onboarding_getStarted: '开始使用',
  onboarding_step1Title: "在群里说出你的需求",
  onboarding_step1Desc: "想找什么、想做什么，直接说出来就行。小摇会先和你聊几句澄清细节，帮你整理成清晰有效的一句话，让对的人一眼看懂。",
  onboarding_step2Title: '确认后发布并匹配',
  onboarding_step2Desc: "消息发到群里后，小摇将持续为你摇出最合适的TA，防止消息发完就沉底没人看到。",
  onboarding_step3Title: '匹配后自然聊',
  onboarding_step3Desc: "双方都能看到彼此和小摇聊过的内容，知道对方想要什么。有共同语境，破冰自然不尴尬，聊起来更轻松。",

  // ChannelMembers.vue
  channel_members_empty: '暂无成员',
  channel_members_title: '群成员',
  channel_role_owner: '群主',
  channel_role_admin: '管理员',
  channel_role_member: '成员',

  // Settings.vue
  settings_language: '语言',
  settings_language_followSystem: '跟随系统',

  // ChatBox.vue
  match_interested_suffix: '，{count}个值得一看',

  // ChatBox.vue - AI匹配进度阶段
  match_stage_fetch_chat: '获取对话',
  match_stage_query_expansion: '扩展查询',
  match_stage_semantic_search: '语义搜索',
  match_stage_deep_search: '深度分析',
  match_stage_rerank: '智能匹配',
  match_stage_refining: '优化结果',
  match_stage_fetch_details: '获取详情',

  // ChannelDetail.vue - 图片上传
  channel_select_image: '请选择图片文件',
  channel_image_upload_failed: '图片上传失败，请重试',
  chatInput_channelSearchHint: "搜索群名称",
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js